import WebApiClient from '../api/web'
import { Code } from '../api/base'
import CommonUtil from '../utils/common'

export default {
  beforeMount () {
    this.$root.$children[0].$emit('change-location')
  },
  mounted () {
    if (CommonUtil.isNotEmpty(this.$route.meta.notification)) {
      this.refreshNotification(this.$route.meta.notification.onlyIsNewInfo)
    }
  },
  methods: {
    scrollToAnchor () {
      if (CommonUtil.isNotEmpty(this.$route.hash)) {
        const targetEl = this.$el.querySelector(this.$route.hash)
        if (CommonUtil.isNotNull(targetEl)) {
          targetEl.scrollIntoView()
        }
      }
    },
    changeLocation (name, params = null, replace = false, force = false) {
      this.isValid().then(result => {
        if (result || force) {
          this.onBeforeChangeLocation(name)
          this.$router.push({
            name: name,
            params: params || {},
            replace: replace
          })
        } else {
          this.$forceUpdate()
        }
      })
    },
    onBeforeChangeLocation (name) {
    },
    reload () {
      window.location.reload()
    },
    isValid () {
      return new Promise((resolve) => {
        this.$validator.validateAll().then((result) => {
          resolve(result === true)
        })
      })
    },
    refreshNotification (onlyIsNewInfo = true) {
      WebApiClient.getNotifications(this, onlyIsNewInfo).then((response) => {
        if (response.data.code === Code.SUCCESS) {
          this.onRefreshNotification(response.data.result, onlyIsNewInfo)
          this.$root.$children[0].$emit('update-notifications',
            response.data.result)
        }
      }).catch((e) => {})
    },
    onRefreshNotification (notifications, onlyIsNewInfo) {}
  }
}



// WEBPACK FOOTER //
// ./src/views/base.js